module.exports = "<div class=\"br-crumb\">\n  <div class=\"container-fluid\">\n   <!--  <ol class=\"breadcrumb\">\n      <li>\n        <a href=\"#\">\n          <i class=\"fa fa-home\" aria-hidden=\"true\"></i>\n        </a>\n      </li>\n      <li>\n        <a href=\"#\">CRM</a>\n      </li>\n      <li class=\"active\">LEADS</li>\n    </ol> -->\n  </div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/breadcrumb/breadcrumb.component.html
// module id = ./src/app/layout/breadcrumb/breadcrumb.component.html
// module chunks = main